import { useEffect } from "react";

//Actualiza el <title> del documento según la página (WCAG 2.4.2). Antes el
//título era siempre "Presupuesto Participativo Raíz" en todas las rutas.
//Se le pasa el título propio de la página y le agrega el sufijo de la marca.
//Al desmontar restaura el título base.
const BASE = "Presupuesto Participativo Raíz";

export default function useTituloPagina(titulo) {
  useEffect(() => {
    document.title = titulo ? `${titulo} | ${BASE}` : BASE;
    return () => {
      document.title = BASE;
    };
  }, [titulo]);
}
